import { appUrls } from "~/EasyProjectsCommon/AppUrls";
import { XhrDeferredType } from "~/EasyProjectsCommon/General";
import { reloadTeamsRequest } from "~/Redux/AvailableUsers/teams";
import { uniqueKey } from "~/utils/uniqueKey";
import { EntityCache } from "./EntityCache";

export type TeamInfo = {
    TeamId: number;
    UserIds: number[];
    Name: string;
};

type InvalidateCacheOptions = {
    reloadImmediately: boolean;
};

export class TeamsCache extends EntityCache<TeamInfo> {
    getAllUrl: string;
    keyName: keyof TeamInfo = "TeamId";

    constructor() {
        super();

        this.getAllUrl = TeamsCache.getEntitiesUrl;

        this.ensureLoad();
    }

    static get inst(): TeamsCache {
        return this._instance || (this._instance = new TeamsCache());
    }

    static get getEntitiesUrl(): string {
        return `${appUrls.reference.getVisibleTeams}?version=${ep.settings.cacheVersions.teamsVersion}`;
    }

    static invalidate(options: InvalidateCacheOptions = { reloadImmediately: false }) {
        const newVersion = uniqueKey();
        ep.settings.cacheVersions.teamsVersion = newVersion;
        if (options.reloadImmediately) {
            const newCacheInstance = new TeamsCache();
            newCacheInstance.ensureLoad().then(() => {
                if (newVersion === ep.settings.cacheVersions.teamsVersion) {
                    TeamsCache._instance = newCacheInstance;
                    // availableUsers module uses TeamsCache as data source
                    // so we need to update it too
                    window.store?.dispatch(reloadTeamsRequest());
                }
            });
        } else {
            TeamsCache.reset();
        }
    }

    getAll() {
        if (ep.settings.isGuest) {
            return $.Deferred().resolve([]).promise() as XhrDeferredType;
        }

        return super.getAll();
    }

    protected loadEntities(ids: number[]): JQuery.Promise<TeamInfo[]> {
        throw new Error("loadEntities in TeamsCache is not implemented");
    }

    protected throwDataNotLoaded(): void {
        throw new Error("Teams data for cache are not loaded yet");
    }
}
